define([
    'text!index2021-cooperate/component/item-project.html',
    'index2021-cooperate/mixin/form',
    'index2021-cooperate/component/enum-select'
], function(
    tpl,
    FormMixin,
    EnumSelect
){
    return {
        template: tpl,
        mixins: [FormMixin],
        components: {
            EnumSelect: EnumSelect
        },
        methods: {
            resetForm: function(){
                this.form = {
                    type: 1,
                    companyName: '',
                    projectName: '',
                    city: '',
                    budget: '',
                    inTime: '',
                    contact: '',
                    position: '',
                    tel: '',
                    email: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/component/item-project.js
// module id = 225
// module chunks = 0